import {
  type DraftCartTrackingInput,
  getDraftCartItemCount,
  getDraftCartType,
} from './getDraftCartTrackingFields';

/**
 * What one open of the draft cart dropdown showed, for `appbar-cart-opened`. The three type counts
 * always sum to `cart_count`; modification and emptiness are counted independently of type.
 */
const summarizeDraftCarts = (carts: readonly DraftCartTrackingInput[]) => {
  const summary = {
    cart_count: carts.length,
    cart_ids: carts.map(cart => cart.id),
    group_order_count: 0,
    standard_count: 0,
    unknown_count: 0,
    modification_count: 0,
    empty_cart_count: 0,
  };

  carts.forEach(cart => {
    summary[`${getDraftCartType(cart)}_count` as const] += 1;
    if (cart.isModification) summary.modification_count += 1;
    if (getDraftCartItemCount(cart) === 0) summary.empty_cart_count += 1;
  });

  return summary;
};

export default summarizeDraftCarts;
